<template>
  <v-card class="stat-tile" outlined>
    <div class="stat-tile-top">
      <div class="stat-tile-icon" :class="`stat-tile-icon--${color}`">
        <v-icon :color="iconColor" size="20">{{ icon }}</v-icon>
      </div>
      <span
        v-if="badge"
        class="stat-tile-badge"
        :class="`stat-tile-badge--${color}`"
        >{{ badge }}</span
      >
    </div>
    <span class="stat-tile-value">{{ formattedValue }}</span>
    <span class="stat-tile-label">{{ label }}</span>
    <span v-if="hint" class="stat-tile-hint">{{ hint }}</span>
  </v-card>
</template>

<script>
const ICON_COLOR = {
  primary: "#0f7a6e",
  success: "#0f7a6e",
  secondary: "#2f7fd1",
  error: "#c81e22",
  warning: "#c07a1e",
  neutral: "#6b7580",
  info: "#1f7a7c",
};

export default {
  name: "StatTile",
  props: {
    label: { type: String, required: true },
    value: { type: [Number, String], required: true },
    icon: { type: String, required: true },
    color: { type: String, default: "primary" },
    hint: { type: String, default: "" },
    badge: { type: String, default: "" },
  },
  computed: {
    iconColor() {
      return ICON_COLOR[this.color] || ICON_COLOR.primary;
    },
    formattedValue() {
      return typeof this.value === "number"
        ? this.value.toLocaleString("pt-BR")
        : this.value;
    },
  },
};
</script>

<style src="./styles.scss" scoped lang="scss" />
